import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getSwapKosherFunds, saveBatchSwapKosherFunds } from '../../api/swapKosherFunds';
import type { SwapKosherFund } from '../../types/SwapKosherFund';
import { t } from '../../i18n/t';

const columnDefs: ColDef<SwapKosherFund>[] = [
  {
    field: 'kosherFundId',
    headerName: t('swapKosherFunds.columns.kosherFundId'),
    width: 150,
    cellDataType: 'number',
    editable: (p: EditableCallbackParams<SwapKosherFund>) =>
      (p.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'equivalentFundId', headerName: t('swapKosherFunds.columns.equivalentFundId'), width: 160, editable: true, cellDataType: 'number' },
  { field: 'kosherAssetId', headerName: t('swapKosherFunds.columns.kosherAssetId'), width: 160, editable: true, cellDataType: 'number' },
  { field: 'equivalentAssetId', headerName: t('swapKosherFunds.columns.equivalentAssetId'), width: 170, editable: true, cellDataType: 'number' },
];

const newRowDefaults = (): Partial<SwapKosherFund> => ({
  kosherFundId: 0,
  equivalentFundId: 0,
  kosherAssetId: 0,
  equivalentAssetId: 0,
});

export function SwapKosherFundsPage() {
  return (
    <LopCrudPage<SwapKosherFund>
      resourceCode="swapKosherFunds"
      titleKey="swapKosherFunds.pageTitle"
      idField="kosherFundId"
      getRows={getSwapKosherFunds}
      saveBatch={(added, modified, deletedIds) => saveBatchSwapKosherFunds(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
